import {Component, Input} from "@angular/core";
import {EvaMessage} from "./eva-message";

@Component({
    selector: 'eva-message',
    templateUrl: './eva-message.component.html',
})

export class EvaMessageComponent{
    @Input() message: EvaMessage;

    constructor() { }

}


// WEBPACK FOOTER //
// ./public/upgrade/shared/eva-message/eva-message.component.ts